// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LanguageSelect-module__languageSelect___iOUOn .p-inputtext{min-width:80px}`, "",{"version":3,"sources":["webpack://./src/components/sharedComponents/language/LanguageSelect.module.scss"],"names":[],"mappings":"AAIE,4DACE,cAAA","sourcesContent":[".languageSelect {\n  //   display: flex;\n  //   justify-content: flex-end;\n\n  :global .p-inputtext {\n    min-width: 80px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"languageSelect": `LanguageSelect-module__languageSelect___iOUOn`
};
export default ___CSS_LOADER_EXPORT___;
